export const name = 'auth';

export const FEATURE_ROUTER_PATH = `/${name}`;
